import { render, staticRenderFns } from "./nation.vue?vue&type=template&id=23d13a09&scoped=true"
import script from "./nation.vue?vue&type=script&lang=js"
export * from "./nation.vue?vue&type=script&lang=js"
import style0 from "./nation.vue?vue&type=style&index=0&id=23d13a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d13a09",
  null
  
)

export default component.exports